/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
 

export enum sortCrieriaEnum {
  PRICE = 'Price',
  DEPARTURE_DATE = 'DepartureDate',
}
